import Control from "sap/ui/core/Control";
import { BaseLogFormatter } from "./BaseLogFormatter";
import { FormatDate } from "akademika/akamont/utils/FormatUtil";

export class ServicePriceLogFormatter extends BaseLogFormatter {
  generateControlForValue(
    value: string | null | undefined,
    fieldName: string
  ): Control {
    switch (fieldName) {
      case "ServiceMeasurementUnit":
        return this.getTextForServiceMeasurementUnit(value);
      case "ValidFrom":
      case "ValidTo":
        return this.generateTextControl(FormatDate(value));
      default:
        return this.generateTextControl(value);
    }
  }
}
